import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, deleteDoc, query, where, getDocs, orderBy, updateDoc, collection } from "firebase/firestore";

import { db } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import { Randomcode } from '../components/rendom_code';
//page links      
//help
import { VscCheck } from "react-icons/vsc";
import { VscAdd } from 'react-icons/vsc';
import { VscRemove } from 'react-icons/vsc';
import './account-details.css';

import { Saveusersdetails } from './save_users_details';
import { Saveskilsdetails } from './save_skils_details';
import Loading from '../components/loading';

export default function AccountDetailsKeyskills() {
  const navigate = useNavigate();
  const [UsersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [skillscategories, setSkillscategories] = useState([]);
  const [jobCategories, setJobCategories] = useState([]);
  const [expandedSkill, setExpandedSkill] = useState(null);
  const location = useLocation();
  const details = location.state?.details || {};
  const { showToast } = useToast();
  const formattedTitle = details

    .replace(/_/g, ' ')
    .charAt(0).toUpperCase() + details.replace(/_/g, ' ').slice(1);
  const existingUser = Cookies.get("guid");
  useEffect(() => {
    fetchdetails();
  }, []);


  const fetchdetails = async () => {
    setIsLoading(true);
    try {
      const userQuery = query(
        collection(db, "skils_details"),
        where("guid", "==", existingUser)
      );
      const userSnapshot = await getDocs(userQuery);

      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data()
      }));

      setUsersData(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };


  //skills_categories  
  useEffect(() => {
    const fetchSkillscategoriesData = async () => {
      setIsLoading(true);
      try {
        // Fetch skills categories
        const jq = query(
          collection(db, "skills_categories"),
          where("status", "==", true)
        );
        const skillsSnapshot = await getDocs(jq);

        const skillsData = skillsSnapshot.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data()
        }));

        setSkillscategories(skillsData); // Save skills list to state

        // Fetch job categories for all skills
        const allJobCategories = [];

        for (const skill of skillsData) {
          const jcq = query(
            collection(db, "jobcategories"),
            where("skillsId", "==", skill.uid),
            where("status", "==", true)
          );
          const jobSnapshot = await getDocs(jcq);

          jobSnapshot.forEach((jobDoc) => {
            allJobCategories.push({
              uid: jobDoc.id,
              ...jobDoc.data(),
              skillsId: skill.uid
            });
          });
        }

        setJobCategories(allJobCategories); // Save jobs list to state
      } catch (error) {
        console.error("Error fetching skills or job categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSkillscategoriesData();
  }, []);

  const RemoveSkillscategories = async (skilsdetails) => {
    try {
      const jcq = query(
        collection(db, "skils_details"),
        where("uid", "==", skilsdetails)
      );

      const snapshot = await getDocs(jcq);

      if (!snapshot.empty) {
        snapshot.forEach(async (docItem) => {
          await deleteDoc(doc(db, "skils_details", docItem.id));
        });
        console.log("Skill category removed successfully.");
        showToast('Removed successfully.');
        setTimeout(() => {
          fetchdetails();
        }, 1000);
      } else {
        console.log("No matching skill category found to remove.");
      }
    } catch (error) {
      console.error("Error removing skill category:", error);
    }
  };

  //save
  const new_saveusersdetails = async (skillsId, skills, jobCategoriesId, jobCategories, description) => {

    const uid = Randomcode(9);
    showToast('Publishing...');
    setIsLoading(true);
    const result = await Saveskilsdetails({
      uid,
      skillsId,
      skills,
      jobCategoriesId,
      jobCategories,
      description,
    });
    if (result.success) {
      showToast('Successfully saved');
      setTimeout(() => {
        fetchdetails();
        // navigate(`/account`);
      }, 1000);
    } else {
      showToast("Failed to publish post: " + (result.error || "Unknown error"));
      console.error("Save Error:", result.error);
    }
  };
  return (

    <div className='post-container'>

      <div className='post_div'>

        <div>
          {isLoading ? (
            <Loading />
          ) : (
            <table className='skillscategories-table'>
              <tbody>
                {UsersData.map((cat, index) => {
                  const checkboxId = `chk-${index}`;
                  return (
                    <tr key={index}>
                      <td>
                        <div className="skillscategory-item">
                          <div className="title-row">
                            <div className="title-text">
                              {cat.skills + ": " + cat.jobCategories}
                            </div>

                            {/* Checkbox */}
                            <table>
                              <tr>
                                <td>
                                  <input type="checkbox" id={checkboxId} style={{ marginRight: '6px' }} />

                                </td>
                                <td> <label for='checkboxId'  >Agree</label></td>
                              </tr>
                            </table>

                            {/* Label for the checkbox that acts like a button */}
                            <label
                              htmlFor={checkboxId}
                              className="button-ui3"
                              style={{ cursor: "pointer", color: "#d00" }}
                              onClick={() => {
                                const isChecked = document.getElementById(checkboxId).checked;
                                if (isChecked) {
                                  RemoveSkillscategories(cat.uid);
                                } else {
                                  showToast("Please check the box to agree before removing.");
                                }
                              }}
                            >
                              <VscRemove className="icon" /> Remove
                            </label>
                          </div>

                          <div className="description-text">{cat.description}</div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        <div>
          {isLoading ? (
            <Loading />
          ) : (
            <table className='skillscategories-table'>
              <tbody>
                {skillscategories.map((cat, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td>
                        <div className="skillscategory-item">
                          <div className="title-row">
                            <div className="title-text">{cat.title}</div>
                            <div
                              className="button-ui"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                setExpandedSkill(expandedSkill === cat.uid ? null : cat.uid)
                              }
                            >
                              <VscAdd className='icon' /> {expandedSkill === cat.uid ? "Collapse" : "Expand"}
                            </div>
                          </div>
                          <div className="description-text">{cat.description}</div>
                        </div>
                      </td>
                    </tr>
                    {expandedSkill === cat.uid && (
                      <tr>
                        <td>
                          <div className="jobcategories-list">
                            {jobCategories.filter((job) => job.skillsId === cat.uid).length > 0 ? (
                              jobCategories
                                .filter((job) => job.skillsId === cat.uid)
                                .map((job) => (
                                  <div key={job.uid} className="jobcategory-item">
                                    <div className="title-row">
                                      <div className="title-text">{job.title}</div>
                                      <div
                                        className="button-ui"
                                        onClick={() =>
                                          new_saveusersdetails(
                                            job.skillsId,
                                            job.skillscategories,
                                            job.categoryId,
                                            job.title,
                                            job.description
                                          )
                                        }
                                      >
                                        <VscAdd className="icon" /> Add
                                      </div>
                                    </div>
                                  </div>
                                ))
                            ) : (
                              <div className="no-jobs">No job categories available.</div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div>
          <br />
          <div className='button-ui' onClick={new_saveusersdetails}><VscCheck className='icon' /> Save</div>
        </div>
      </div>

    </div>

  );
}
